module.exports = __webpack_public_path__ + "img/crypto-exchange-gold.05e368ed.svg";